exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autodesk-logo-header[data-v-704ff099]{height:-webkit-min-content;height:-moz-min-content;height:min-content;margin-bottom:0;border-radius:0;min-height:60px;padding-right:28px;padding-left:28px;border:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.change-password-body[data-v-704ff099]{min-width:315px}.change-password-header[data-v-704ff099]{background-color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports
